import React from "react";
import { Category, SelectProduct } from "../../../types/salon.types";
import CategoryCard from "../Common/CategoryCard";
import ProductCard from "./ProductCard";

interface ProductSectionProps {
  categories?: Category[];
  products: SelectProduct[];
  displayMode?: "grid" | "list";
  onCategorySelect?: (categoryId: string) => void;
  onProductSelect?: (product: SelectProduct) => void;
  selectedProducts?: SelectProduct[];
}

const ProductSection: React.FC<ProductSectionProps> = ({
  categories = [],
  products,
  displayMode = "list",
  onCategorySelect,
  onProductSelect,
  selectedProducts = []
}) => {
  if (displayMode === "list" && categories.length > 0) {
    return (
      <div className="staff-section">
        <h2 className="saloon-title">Categories</h2>
        <div className="staff-container">
          {categories.length > 0 ? (
            categories.map(category => (
              <CategoryCard
                key={category._id.$oid}
                category={category}
                onClick={() => onCategorySelect && onCategorySelect(category._id.$oid)}
              />
            ))
          ) : (
            <p className="no-staff">No categories found.</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="product-card-details">
      <div className="product-list-container">
        <div className="product-list-header">
          <h2 className="list-title">Products List</h2>
        </div>

        <div className="products-grid">
          {products.map(product => {
            const isSelected = selectedProducts.some(p => p._id.$oid === product._id.$oid);
            return (
              <ProductCard
                key={product._id.$oid}
                product={product}
                isSelected={isSelected}
                onSelect={onProductSelect || (() => {})}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProductSection;